// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__ZOY0F","loaderImg":"Loader_loaderImg__jthFU","backdrop":"Loader_backdrop__KXueo"};